module.exports = __webpack_public_path__ + "media/images/category/feature/coj_b/coj_b-5-03754b517d10f08d58f8087ae078cd49.jpg";